export { default } from "./ServiceTitle-component";
